import React from 'react';
import styled, { css } from 'styled-components';
import Slick from 'react-slick';

const parentWidth = document.getElementById('rcroot').getBoundingClientRect().width;

const ImageContainer = styled.div`
  width: calc(100% - 100px);
  position: relative;
  left: 50%;
  transform: translateX(-50%);

  @media screen and (max-width: 500px) {
    width: 100% !important;
  }

  ${(parentWidth < 501) && css`
    width: 100% !important;
  `};
`;

const ProgressImage = styled.div`
  width: 100%;
  min-height: 200px;
  object-fit: cover;
  background-image: url(${({ src }) => src});
  background-size: contain;
  background-position: center;
  background-repeat: no-repeat;
`;

const settings = {
  dots: false,
  infinite: true,
  speed: 500,
  slidesToShow: 1,
  slidesToScroll: 1,
};

const Slider = ({ images, imageUrl }) => (
  <Slick {...settings}>
    {
      images.map(({ path, thumb }, index) => (
        <ImageContainer key={`${path}-${thumb}`}>
          <ProgressImage
            id={index}
            src={imageUrl(images[index].path)}
            onDragStart={(e) => e.preventDefault}
          />
        </ImageContainer>
      ))
    }
  </Slick>
);

export default Slider;
